import { PurseMovementSchema } from '@/queries/transactions/transactions.types'
import { currencyFormatter } from '../../utilities'
import { Card, CardContent, CardHeader } from '../Card'
import { FormRowLayout, FormRowValue } from '../FormRow/FormRow'

type Props = {
  purses: PurseMovementSchema[]
}

export function PurseMovementCard({ purses }: Props) {
  return (
    <Card>
      <CardHeader>
        <h2 className="text-lg font-bold">Purses</h2>
      </CardHeader>
      <CardContent>
        {purses.map((purse, index) => (
          <FormRowLayout key={index}>
            <div>
              {purse.name}
              <div className="font-normal">{purse.student_name}</div>
            </div>
            <FormRowValue>
              {currencyFormatter.format(purse.amount)}
            </FormRowValue>
          </FormRowLayout>
        ))}
      </CardContent>
    </Card>
  )
}
